export const CAPABILITY_FEATURE_SLUGS = [
  'view_analytics',
  'create_custom_reports',
  'view_user_details',
  'view_sonar_section',
  'view_preferred_content',
  'view_top_users',
  'use_playlists',
  'view_certifications_table',
] as const;

export type CapabilityFeatureSlug = typeof CAPABILITY_FEATURE_SLUGS[number];

export type CapabilityFlags = Record<CapabilityFeatureSlug, boolean>;

export interface CapabilitySelectors {
  canViewAnalytics: boolean;
  canCreateCustomReports: boolean;
  canOpenUserDetails: boolean;
  canViewSonarSection: boolean;
  canViewPreferredContent: boolean;
  canViewTopUsers: boolean;
  canUsePlaylists: boolean;
  canViewCertificationInsights: boolean;
}

export interface CapabilitiesContextValue extends CapabilitySelectors {
  capabilities: CapabilityFlags;
}
